module.exports = __webpack_public_path__ + "static/media/data_analyst_use_case_3.0f6a8ed9.svg";